import React from 'react'

export default function SolutionIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6156_5833)">
        <path d="M3.9375 1.68677H1.6875C1.38914 1.68677 1.10298 1.8053 0.892005 2.01627C0.681026 2.22726 0.5625 2.5134 0.5625 2.81177V16.3118C0.5625 16.6101 0.681026 16.8963 0.892005 17.1073C1.10298 17.3183 1.38914 17.4368 1.6875 17.4368H16.3125C16.6108 17.4368 16.897 17.3183 17.108 17.1073C17.319 16.8963 17.4375 16.6101 17.4375 16.3118V2.81177C17.4375 2.5134 17.319 2.22726 17.108 2.01627C16.897 1.8053 16.6108 1.68677 16.3125 1.68677H8.4375" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.4375 8.43675L6.1875 6.75002L3.9375 8.4375V1.12502C3.9374 1.05109 3.95188 0.977858 3.9801 0.909525C4.00833 0.841193 4.04975 0.7791 4.10199 0.726786C4.15423 0.674473 4.21628 0.632973 4.28457 0.604657C4.35287 0.576342 4.42607 0.561768 4.5 0.561768H7.875C8.02418 0.561768 8.16728 0.621031 8.27273 0.72652C8.37825 0.832013 8.4375 0.975083 8.4375 1.12427V8.43675Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.9375 14.0618H11.8125" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.9375 10.6868H14.0625" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.0625 7.31177H10.6875" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6156_5833">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
